function countdown(elementName, time) {
    var duration = 60 * time;
    var timer = duration, minutes, seconds;
    const interval = setInterval(function () {
        minutes = parseInt(timer / 60, 10)
        seconds = parseInt(timer % 60, 10);

        minutes = minutes < 10 ? "" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;

        elementName.html(minutes + ':' + seconds);
        if (--timer < 0) {
            timer = 0;
            clearInterval(interval);
        }
    }, 1000);
}

export default countdown;
